import Layout from "@/components/layouts/Main";
import { HomepageHero } from "@/components/global/HomepageHero";
import ElementalArea from "@/components/global/ElementalArea";
import { HomePageType } from "@/types/index";

type PageProps = {
    page: HomePageType;
};

const HomePage = ({ page }: PageProps) => {
    return (
        <Layout page={page}>
            {/* <HomepageHero page={page} /> */}

            <ElementalArea ElementalArea={page.ElementalArea} />
        </Layout>
    );
};

export default HomePage;
